import React, { useMemo } from 'react';

import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister';
import { QueryClient } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';

import { useDebug } from 'components/Debug';

import MessageContext from './MessageContext';

export const ReactQueryProvider = ({
  children,
  showErrorMessage,
  showSuccessMessage,
  showMessage,
}: any) => {
  const { query: debugQuery } = useDebug();
  const queryClient = useMemo(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            cacheTime: debugQuery ? 0 : 1000 * 60 * 60 * 15, // 15 days
            refetchOnWindowFocus: false,
            refetchOnMount: true,
            // @ts-ignore
            retry: (failureCount: number, error: string) => {
              if (error?.includes('Authorization')) {
                return 5 - failureCount;
              }
              return 2 - failureCount;
            },
            retryDelay: (attemptIndex: number) => {
              return Math.min(1000 * 2 * attemptIndex, 30000);
            },
            keepPreviousData: true,
          },
        },
      }),
    []
  );
  const persister = useMemo(
    () =>
      createSyncStoragePersister({
        storage: window.localStorage,
      }),
    []
  );

  return (
    <MessageContext.Provider
      value={{ showErrorMessage, showSuccessMessage, showMessage }}
    >
      <PersistQueryClientProvider
        client={queryClient}
        persistOptions={{ persister }}
      >
        {children}
        {debugQuery ? <ReactQueryDevtools /> : null}
      </PersistQueryClientProvider>
    </MessageContext.Provider>
  );
};
